import { isAllowedForAsk } from '@hotjar/feedback/domain/common/Feature/feature';

/**
 * CUSTOM FUNCTIONS FOR CHECKING AVAILABILITY WITHIN THE ASK SKU
 * Functionality to decide if a feature can be used or not.
 * Check order: default features based on Ask plan (or general plan if it does not exist)
 * site.features, org.features, account.features.
 */
angular.module('hjApp.user').service('AskFeature', function ($rootScope, Account, Plan, UserData) {
    /**************************
     * PUBLIC ACCESS FUNCTIONS
     **************************/

    /**
     * Check if a feature can be used by a specific site.
     * This function checks in site, organization or account.
     *
     * @param featureName Name of feature.
     * @param site Site to check for. Defaults to UserData.currentSite.
     */
    this.isAllowedForAsk = (featureName, site) => {
        return isAllowedForAsk(featureName, site || UserData.currentSite);
    };

    /**
     * Return an object about limits for a specific feature.
     * @param feature Name of feature.
     * @param count The count is used to check if this limit has been reached.
     * @param site Site to check for. Defaults to UserData.currentSite.
     */
    this.getLimitsForAsk = function (feature, count, site) {
        let plan,
            planLimit,
            limitReached = false;

        count = count || null;
        site = site || UserData.currentSite;

        // We might not have a site available. E.g. User is not logged in.
        if (!site) {
            return null;
        }

        plan = getSiteAskPlan(site);
        planLimit = window.settings.plans[plan].limits[feature];

        if (!planLimit) {
            // There is no limit for this feature on this plan.
            planLimit = false;
        } else if (planLimit && count) {
            // There is a limit and we have a count. Check if the limit has been reached.
            limitReached = count >= planLimit;
        } else if (planLimit && count === null) {
            // There is a limit but we don't have the count available yet.
            limitReached = undefined;
        }

        return {
            applies: Boolean(planLimit),
            count: planLimit,
            reached: limitReached
        };
    };

    /**
     * Return the lowest tier plan a feature is available on, null if not available on any.
     * @param feature Name of feature.
     */
    this.requiredAskPlan = function (feature) {
        let lowestTierPlan;

        if (!feature) {
            throw new Error('Feature.plan(): You must specify (pass) a feature name to use this function.');
        }

        // Go through each plan and check that:
        // 1. This account has access to this plan.
        // 2. The feature is allowed on this plan.
        // 3. Is a lower plan than the lowest if we have one.
        Object.keys(window.settings.plans).forEach((key) => {
            const plan = window.settings.plans[key];
            if (plan.features.includes(feature) && (!lowestTierPlan || plan.tier < lowestTierPlan.tier)) {
                lowestTierPlan = {
                    name: key,
                    tier: plan.tier
                };
            }
        });

        if (lowestTierPlan) {
            return lowestTierPlan.name;
        }
    };

    /*******************
     * PRIVATE FUNCTIONS
     *******************/
    function getSiteAskPlan(site) {
        const effectiveData = Plan.get(site).effective;
        // fallback to standard effective plan if feedback plan is not present
        return effectiveData.feedback_plan ? effectiveData.feedback_plan : effectiveData.name;
    }
});
